import { GetterTree } from "vuex";
import { RootState } from "../types";
import { SubscriptionsInt } from "./types";
export const getters: GetterTree<SubscriptionsInt, RootState> = {};
